import { CommandBase } from "../CommandBase.js";

export class BlogCommand extends CommandBase {
    async execute(args) {
        this.write("FIELD REPORTS DATABASE:", "text-accent");
        this.writeHTML(`<div class="terminal-spacer">&nbsp;</div>`);
        
        const posts = this.contentManager.getBlogPosts();
        
        if (!posts || posts.length === 0) {
            this.write("No field reports found.", "text-danger");
            return;
        }

        posts.forEach(post => {
            const html = `
                <div class="terminal-list-item">
                    <span class="text-muted">[${post.date}]</span> 
                    <strong class="text-primary">${post.title}</strong>
                    <br>
                    <span class="text-muted terminal-indent">» ${post.excerpt}</span>
                    <div class="terminal-indent small text-muted-dim">
                        ID: ${post.id}
                    </div>
                </div>
            `;
            this.writeHTML(html);
        });
        
        // ✅ SMARTER INSTRUCTIONS
        const currentDir = this.fileSystem.getCurrentDirectory();
        const projectsPath = '/home/user/blog';

        this.writeHTML(`<div class="terminal-spacer">&nbsp;</div>`);
        this.write("To interact, run:", "text-muted");
        
        if (currentDir === projectsPath) {
            this.write("  ls", "text-accent");
        } else {
            this.write(`  cd ${projectsPath}`, "text-accent");
            this.write("  ls", "text-accent");
        }
        this.write("  cat [file]", "text-accent");
        }
    }